// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { myListsEditListFormStyles } from "@insite/content-library/Widgets/MyLists/MyListsEditListForm";
import { mergeWithCss, modalButtonsActionStyles, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

myListsEditListFormStyles.container = {
    gap: 24,
};

myListsEditListFormStyles.buttonsGridItem = {
    ...mergeWithCss(modalButtonsActionStyles.buttonsGridItem, {
        css: css`
            ${xScreen("lte", "xs")} {
                flex-direction: column-reverse;
            }
        `,
    }),
};

myListsEditListFormStyles.cancelButton = {
    ...mergeWithCss(modalButtonsActionStyles.cancelButton, {
        css: css`
            ${xScreen("lte", "xs")} {
                width: 100%;
            }
        `,
    }),
};

myListsEditListFormStyles.createButton = {
    ...mergeWithCss(modalButtonsActionStyles.submitButton, {
        css: css`
            ${xScreen("lte", "xs")} {
                width: 100%;
            }
        `,
    }),
};
